<template>
    <div class="join_us_div">
        <div>
            <div class="join_banner">
                <img :src="imgSrc[0]"/>
            </div>
            <div class="allContentWidth">
                <div class="join_dz_title">
                    <div class="join_dz_img">
                        <!-- <img :src="imgSrc[1]"/> -->
                        <p>东志国际期待您的加入</p>
                        <div class="line_div_box"></div>
                    </div>
                </div>
                <div class="filtrate_div">
                    <div class="workplace_style">
                        <span>工作地点：</span>
                          <!-- @on-change="workplaceChangeFun" -->
                        <Select v-model="workplace" style="width:220px!important">
                            <Option v-for="item in workplaceList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </div>
                    <div>
                        <span>职位：</span>
                        <Select v-model="position" style="width:220px!important" @on-change="positionChangeFun">
                            <Option v-for="item in positionList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </div>
                </div>
                <div class="table_job_div">
                    <div class="job_box">
                        <span>职位</span>
                        <span>工作地点</span>
                        <span>投递邮箱</span>
                    </div>
                    <Collapse v-model="value2"   class="collapse_box">
                        <Panel  v-for="item in joinFilter" :key="item.zw_title" :name="item.zw_title" class="panel_s">
                            <span class="title_span_s"><b>{{item.zw_title}}</b><b>{{item.job_place}}</b><b>{{item.send_email}}</b></span>
                            <div slot="content">
                                <div class="join_job_duty_condition_box">
                                    <div class="join_left">
                                        <span class="duty_condition_title">工作职责：</span>
                                        <p v-for="j in item.job_duties" :key="j.key">
                                            {{`${j.key}、${j.value}；`}}
                                        </p>
                                    </div>
                                    <div class="join_right">
                                        <span class="duty_condition_title">任职条件：</span>
                                        <p v-for="r in item.job_condition" :key="r.key">
                                            {{`${r.key}、${r.value}；`}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    </Collapse>
                </div>
                <div class="table_job_div_mobile">
                    <div class="job_box">
                        <span>职位</span>
                        <span>工作地点</span>
                    </div>
                    <Collapse v-model="value2"   class="collapse_box">
                        <Panel  v-for="item in joinFilter" :key="item.zw_title" :name="item.zw_title" class="panel_s">
                            <span class="title_span_s"><b>{{item.zw_title}}</b><b>{{item.job_place}}</b></span>
                            <div slot="content">
                                <div>
                                    投递邮箱：<b>{{item.send_email}}</b>
                                </div>
                                <div class="join_job_duty_condition_box">
                                    <div class="join_left">
                                        <span class="duty_condition_title">工作职责：</span>
                                        <p v-for="j in item.job_duties" :key="j.key">
                                            {{`${j.key}、${j.value}；`}}
                                        </p>
                                    </div>
                                    <div class="join_right">
                                        <span class="duty_condition_title">任职条件：</span>
                                        <p v-for="r in item.job_condition" :key="r.key">
                                            {{`${r.key}、${r.value}；`}}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </Panel>
                    </Collapse>
                </div>
                <!-- <div class="join_content">
                    <div class="join_con_div" v-for="item in joinArr" :key="item.id">
                        <div class="join_job_title_box">
                            <div class="join_job_title">
                                <div class="join_line_div"></div>
                                <p>职位： {{item.zw_title}}</p>
                            </div>
                            <div class="join_workplace_email_div">
                                <span class="join_workplace_text">工作地点: {{item.job_place}}</span>
                                <span>投递邮箱：{{item.send_email}}</span>
                            </div>
                        </div>
                        <div class="join_job_duty_condition_box">
                            <div class="join_left">
                                <span class="duty_condition_title">工作职责：</span>
                                <p v-for="j in item.job_duties" :key="j.key">
                                    {{`${j.key}、${j.value}；`}}
                                </p>
                            </div>
                            <div class="join_right">
                                <span class="duty_condition_title">任职条件：</span>
                                <p v-for="r in item.job_condition" :key="r.key">
                                    {{`${r.key}、${r.value}；`}}
                                </p>
                            </div>
                        </div>
                    </div>
                </div> -->
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        components: {},
        computed: {},
        mounted() {
            this.positionChangeFun('全部');
        },
        watch: {},
        methods: {
            workplaceChangeFun(val){
                var list = [...this.joinArr];
                if(val!=='全部'){
                    var arr = [];
                    list.map((item)=>{
                        if(item.job_place === val){
                           arr.push(item);
                        }
                    })
                    this.joinFilter = arr;
                }else{
                    this.joinFilter = list;
                }
            },
            positionChangeFun(val){
                var list = [...this.joinArr];
                if(val!=='全部'){
                    var arr = [];
                    list.map((item)=>{
                        if(item.zw_title === val){
                           arr.push(item);
                        }
                    })
                    this.joinFilter = arr;
                }else{
                    this.joinFilter = list;
                }
            },
        },
        data() {
            var imgSrc = [];
            imgSrc.push(require('../../assets/img/shi1.png'));//(0)
            imgSrc.push(require('../../assets/img/joinUs/dongzhi_title.png'));//(1)
            return {
                imgSrc: imgSrc,
                value2: '',//海运单证
                workplace:'全部',
                workplaceList:[
                    {value: '全部',label: '全部'},
                    {value: '上海',label: '上海'},
                    {value: '宁波',label: '宁波'},
                    {value: '广州',label: '广州'},
                    {value: '深圳',label: '深圳'},
                    {value: '厦门',label: '厦门'},
                    {value: '青岛',label: '青岛'},
                    // {value: '深圳',label: '深圳'},
                ],
                position: '全部',
                positionList:[
                    {value: '全部',label: '全部'},
                    {value: '海运单证',label: '海运单证'},
                    {value: '海运操作',label: '海运操作'},
                    {value: '校园实习生',label: '校园实习生'},
                ],
                joinFilter:[],
                joinArr:[
                    {
                        id: 1,
                        zw_title: '海运单证',
                        job_place: '上海',
                        send_email: 'janeca@eastrongintl.com',
                        job_duties:[
                            {key: 1,value: '制作海运提单，提供给客户核对和确认'},
                            {key: 2,value: '费用的核对和结算'},
                            {key: 3,value: '协助操作处理单证方面的工作'},
                            {key: 4,value: '相关表格、文件、数据的处理及归档'},
                            {key: 5,value: '与发货人、目的港代理、供应商保持良好的沟通关系'},
                            {key: 6,value: '完成上级安排的其他相关工作'},
                        ],
                        job_condition:[
                            {key: 1,value: '全日制大专（含大专）以上学历，优秀应届生亦可'},
                            {key: 2,value: '熟悉海运业务出口单证'},
                            {key: 3,value: '熟练使用各种办公软件及自动化设备'},
                            {key: 4,value: '英语有基本读写能力，大学英语四级或以上的优先考虑'},
                            {key: 5,value: '工作责任心强，思路敏捷，口头表达能力佳'},
                        ],
                    },
                    {
                        id: 2,
                        zw_title: '海运操作',
                        job_place: '上海',
                        send_email: 'janeca@eastrongintl.com',
                        job_duties:[
                            {key: 1,value: '熟悉海运进出口业务流'},
                            {key: 2,value: '能独立处理订舱、托书、系统录入，安排进仓、做箱、拖车报关等事宜'},
                            {key: 3,value: '和上下游订舱口、船公司、报关公司、客户等保持紧密联系'},
                            {key: 4,value: '负责操作文档的整理和归档，发送预报和及时快递发票和退单等'},
                            {key: 5,value: '客户投诉、纠纷的处理及上级交办的其他相关工作'},
                        ],
                        job_condition:[
                            {key: 1,value: '全日制大专（含大专）以上学历'},
                            {key: 2,value: '3年以上物流企业操作经验，精通海运进出口操作流程，一票到底，操作直客优先'},
                            {key: 3,value: '英语有基本读写能力，大学英语四级或以上的优先考虑'},
                            {key: 4,value: '工作细心、责任心强，具有较强的服务意识和团队精神'},
                            {key: 5,value: '服务意识强，能承受一定的工作压力，并善于处理各种突发的问题'},
                        ],
                    },
                    {
                        id: 3,
                        zw_title: '校园实习生',
                        job_place: '上海',
                        send_email: 'janeca@eastrongintl.com',
                        job_duties:[
                            {key: 1,value: '整理单证资料'},
                            {key: 2,value: '系统数据录入'},
                            {key: 3,value: '其他文档资料整理'},
                        ],
                        job_condition:[
                            {key: 1,value: '做事细致仔细，有耐心'},
                            {key: 2,value: '沟通性强，熟练使用offic等办公软件'},
                            {key: 3,value: '在校学生，每周至少工作三天'},
                            {key: 4,value: '底薪+年底双薪 + 绩效奖金 + 带薪培训 + 各种补贴'},
                            {key: 5,value: '丰富多彩的员工活动，定期安排体检，优秀团队聚餐、旅游等活动，拥有轻松、 人性化的工作氛围和优秀的企业文化'},
                        ],
                    }
                ],
            }
        }
    }
</script>
<style lang="less">
.join_us_div{
    background: #f7f7f7;
    .join_banner{
        width:100%;
        img{
            width:100%;
            height:100%;
        }
    }
    .join_dz_title{
        display: flex;
        justify-content: center;
        .join_dz_img{
            // margin: 70px 0 30px 0;
            // border: 1px  dashed #999;
            // img{
            //     width:100%;
            //     height:100%;
            // }
            margin: 50px 0 30px 0;
            font-size: 30px;
            font-weight: 700;
            .line_div_box{
                background: #2200ba;
                width: 30px;
                height: 4px;
                margin: auto;
            }
            img{
                width:100%;
                height:100%;
            }
        }
    }
    .filtrate_div{
        display: flex;
        // justify-content: space-around;
        margin: 30px 0 50px 0;
        .workplace_style{
            margin-right: 80px;
        }
    }
    .table_job_div{
        padding: 20px 0 80px 0;
        .job_box{
            background: #f2f2f2;
            padding: 20px 0 20px 50px;
            font-size: 18px;
            font-weight: bold;
            border: 1px solid #dcdee2;
            span{
                width: 15%;
                display: inline-block;
                text-align: center;
            }
            span:nth-child(2){
                margin: 0 20%;
            }
        }
        .collapse_box{
            .panel_s{
                .ivu-collapse-header{
                    height: 0px!important;
                    line-height: 0px!important;
                    padding: 20px 0 30px 16px !important;
                }
                .title_span_s{
                    b{
                        font-weight: normal;
                        font-size: 16px;
                        width: 14%;
                        display: inline-block;
                        text-align: center;
                    }
                    b:nth-child(2){
                        margin: 0 20%;
                    }
                }
                .join_job_duty_condition_box{
                    padding-left: 15px;
                    font-size: 14px;
                    line-height: 40px;
                    color: #3F3F3F;
                    display: flex;
                    justify-content: space-between;
                    margin: 8px 0 30px 0;
                    .duty_condition_title{
                        font-size: 16px;
                    }
                    .join_left{
                        width: 45%;
                    }
                    .join_right{
                        width: 45%;
                    }
                }
            }
        }
    }
    .table_job_div_mobile{
        display: none;
    }
    .join_content{
        margin: 20px 0 30px 0;
        .join_con_div{
            border-bottom: 1px solid #cccccc;
            padding: 30px 50px 0 50px;
            .join_job_title_box{
                line-height: 60px;
                border-bottom: 1px dashed #999;
                .join_job_title{
                    display: flex;
                    font-size: 22px;
                    line-height: 22px;
                    .join_line_div{
                        width: 4px;
                        height: 22px;
                        background:  #2200ba;
                        margin: 0 15px 0 0;
                    }
                }
                .join_workplace_email_div{
                    margin: 0 0 0 15px;
                    font-size: 16px;
                    .join_workplace_text{
                        margin-right: 60px;
                    }
                }
            }
            .join_job_duty_condition_box{
                padding-left: 15px;
                font-size: 14px;
                line-height: 40px;
                color: #3F3F3F;
                display: flex;
                justify-content: space-between;
                margin: 8px 0 30px 0;
                .duty_condition_title{
                    font-size: 16px;
                }
                .join_left{
                    width: 45%;
                }
                .join_right{
                    width: 45%;
                }
            }
        }
        .join_con_div:last-child{
           border-bottom: none;
        }
    }
}
@media screen and (max-width:900px){
    .join_us_div{
        .table_job_div{
            display: none;
        }
        //筛选条件
        .filtrate_div{
            flex-direction: column;
            div{
                span{
                    width: 80px;
                    display: inline-block;
                    text-align: right;
                }
                .ivu-select{
                    width:200px!important;
                }
            }
            .workplace_style{
                margin-bottom: 15px;
            }
        }
        //折叠面板相关内容
        .table_job_div_mobile{
            display: block;
            padding: 20px 0 80px 0;
            .job_box{ //表头
                background: #f2f2f2;
                padding: 20px 0 20px 50px;
                font-size: 18px;
                font-weight: bold;
                border: 1px solid #dcdee2;
                span{
                    width: 25%;
                    display: inline-block;
                    text-align: center;
                }
                span:nth-child(2){
                    margin: 0 20%;
                }
            }
            .collapse_box{
                .panel_s{
                    .ivu-collapse-header{
                        height: 0px!important;
                        line-height: 0px!important;
                        padding: 20px 0 30px 16px !important;
                    }
                    .title_span_s{
                        b{
                            font-weight: normal;
                            font-size: 16px;
                            width: 24%;
                            display: inline-block;
                            text-align: center;
                        }
                        b:nth-child(2){
                            margin: 0 20%;
                        }
                    }
                    .join_job_duty_condition_box{
                        padding-left: 15px;
                        font-size: 14px;
                        line-height: 40px;
                        color: #3F3F3F;
                        flex-direction: column;
                        margin: 8px 0 30px 0;
                        .duty_condition_title{
                            font-size: 16px;
                        }
                        .join_left{
                            width: 100%;
                        }
                        .join_right{
                            width: 100%;
                        }
                    }
                }
            }

        }
        .join_content{
            .join_con_div{
                padding: 30px 20px 0 20px;
                .join_job_title_box{
                    .join_workplace_email_div{
                        display: flex;
                        flex-direction: column;
                    }
                }
                .join_job_duty_condition_box{
                    display: flex;
                    flex-direction: column;
                    .join_left{
                        width: 100%;
                    }
                    .join_right{
                        width: 100%;
                    }
                }
            }
        }
    }
}
</style>
